import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export const setButtonColor = () => {
    switch (process.env.NEXT_PUBLIC_BUTTON_COLOR_SET) {
        case 'LIGHT': {
            return 'bg-gray-100 text-gray-900';
        }
        case 'DARK': {
            return 'bg-gray-900 text-gray-100';
        }
    }
};

import { ReadonlyURLSearchParams } from 'next/navigation';
import { PageSectionType } from '@/app/[locale]/admin/pages-sections/pageSectionType';
import slugify from 'slugify';

export const createUrl = (
    pathname: string,
    params: URLSearchParams | ReadonlyURLSearchParams,
) => {
    const paramsString = params.toString();
    const queryString = `${paramsString.length ? '?' : ''}${paramsString}`;

    return `${pathname}${queryString}`;
};

export const ensureStartsWith = (stringToCheck: string, startsWith: string) =>
    stringToCheck.startsWith(startsWith)
        ? stringToCheck
        : `${startsWith}${stringToCheck}`;

export const validateEnvironmentVariables = () => {
    const requiredEnvironmentVariables = [
        'NEXT_PUBLIC_ECWID_STORE_ID',
        'ECWID_API_KEY',
    ];
    const missingEnvironmentVariables = [] as string[];

    requiredEnvironmentVariables.forEach(envVar => {
        if (!process.env[envVar]) {
            missingEnvironmentVariables.push(envVar);
        }
    });

    if (missingEnvironmentVariables.length) {
        throw new Error(
            `The following environment variables are missing. Your site will not work without them.\n\n${missingEnvironmentVariables.join(
                '\n',
            )}\n`,
        );
    }
};

export const cartesianProduct = <T>(...allEntries: T[][]): T[][] => {
    return allEntries.reduce<T[][]>(
        (results, entries) =>
            results
                .map(result => entries.map(entry => result.concat([entry])))
                .reduce((subResults, result) => subResults.concat(result), []),
        [[]],
    );
};

export const formatPostalCode = (postalCode: string) => {
    const postalCodeRegex = new RegExp(
        /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ ]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/,
    );
    if (postalCodeRegex.test(postalCode)) {
        postalCode = postalCode.replace(/ /g, '');
        postalCode = postalCode.toUpperCase();
        postalCode = postalCode.slice(0, 3) + ' ' + postalCode.slice(3);
    }
    return postalCode;
};

export const formatPhone = (phone: string) => {
    try {
        if (!phone) {
            return null;
        }
        phone = phone.toString().replace(/[^\d]/g, '');
        if (phone.length == 10) {
            return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        }
        return null;
    } catch {
        return null;
    }
};

export const getSectionName = (section: PageSectionType, locale: string) => {
    if (!section.name) {
        return `image-${section.id}`;
    }
    if (section.name[locale].length > 0) {
        return slugify(section.name[locale]);
    }
    return `image-${section.id}`;
};
